import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import adLogo from '../../../src/assets/images/logo_white_aduleek_full.png';

const FooterLink = ({ to, children, className = '' }) => (
    <Link to={to} target="_blank" className={`text-decoration-none ${className}`}>
        <span className="text-white small" style={{ cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap' }}>
            {children}
        </span>
    </Link>
);

const Footer = () => {
    const copyrightYear = `2024-${new Date().getFullYear()}`;

    const footerLinks = [
        { to: '/about-us', label: 'About Us' },
        { to: '/contact-us', label: 'Contact Us' },
        { to: '/terms-and-conditions', label: 'Terms and Conditions' },
        { to: '/privacy-policy', label: 'Privacy Policy' },
        { to: '/cookies-policy', label: 'Cookies Policy' },
        { to: '/content-policy', label: 'Content Policy' },
    ];

    const footerLinksRow1 = footerLinks.slice(0, 3);
    const footerLinksRow2 = footerLinks.slice(3);

    return (
        <footer className="footer mt-auto py-2 text-white" style={{ backgroundColor: '#182129' }}>
            <Container>
                <div className="d-none d-lg-flex align-items-center justify-content-between flex-nowrap w-100 gap-3">
                    <div className="d-flex align-items-center gap-2 flex-shrink-0">
                        <img src={adLogo} alt="property-logo" style={{ height: '20px', width: 'auto', display: 'block' }} />
                        <p className="mb-0 small d-flex align-items-center" style={{ fontSize: '12px', whiteSpace: 'nowrap', lineHeight: 1 }}>
                            &copy; {copyrightYear} Aduleek Private Limited. All rights reserved.
                        </p>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'flex-end', alignItems: 'center', gap: '16px', flexShrink: 0 }}>
                        {footerLinks.map((link) => (
                            <FooterLink key={link.to} to={link.to}>{link.label}</FooterLink>
                        ))}
                    </div>
                </div>

                <Row className="justify-content-center d-lg-none gy-1">
                    <Col xs={12} className="text-center mb-1">
                        <img src={adLogo} alt="property-logo" style={{ height: '20px', width: 'auto', display: 'inline-block' }} />
                    </Col>
                    <Col xs={12} className="text-center mb-1">
                        <p className="mb-0 small" style={{ fontSize: '13px', lineHeight: 1.3 }}>
                            &copy; {copyrightYear} Aduleek Private Limited. All rights reserved.
                        </p>
                    </Col>
                    <Col xs={12} className="text-center mb-1">
                        <div className="d-flex flex-wrap justify-content-center gap-1 gap-md-2">
                            {footerLinksRow1.map((link) => (
                                <FooterLink key={link.to} to={link.to}>{link.label}</FooterLink>
                            ))}
                        </div>
                    </Col>
                    <Col xs={12} className="text-center">
                        <div className="d-flex flex-wrap justify-content-center gap-1 gap-md-2">
                            {footerLinksRow2.map((link) => (
                                <FooterLink key={link.to} to={link.to}>{link.label}</FooterLink>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
